import { render, staticRenderFns } from "./TestTables.vue?vue&type=template&id=c11f0628&"
import script from "./TestTables.vue?vue&type=script&lang=js&"
export * from "./TestTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports